import { StyleSheet } from 'react-native';
import { bold, fontSizeMediumLarge } from '../../constants/palette';
const styles = StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    title: {
      fontSize: fontSizeMediumLarge,
      fontWeight: bold,
      paddingBottom: 20
    },
    separator: {
      marginVertical: 30,
      height: 1,
      width: '80%',
    },
  });

  export default styles